import Speech from 'speak-tts'

import { removeHtmlTag } from '../../Utils/utils'

export const audioComponent = () => {
  const playBtn = document.querySelector('.audio_component .default_state a')
  const pauseBtn = document.querySelector('.audio_component .playing_state a')
  const playWrapper = document.querySelector('.audio_component .default_state')
  const pauseWrapper = document.querySelector('.audio_component .playing_state')
  const progressBar = document.querySelector('.audio_component .playing_state .progress_bar span')
  let playing = false
  const lang = document.querySelector('html').getAttribute('lang')
  let scrappedText = [...document.querySelectorAll('.audio-tts')]
  scrappedText = scrappedText.map((elt) => elt.innerHTML)
  scrappedText = scrappedText.join('. ')
  scrappedText = removeHtmlTag(scrappedText)

  const readText = scrappedText

  const audioSpeech = new Speech()

  if (!audioSpeech) {
    return false
  }

  audioSpeech
    .init({
      volume: 0.5,
      lang: lang === 'fr' ? 'fr-FR' : 'en-EN',
      rate: 1,
      pitch: 1
    })
    .catch((e) => {
      console.error('An error occured while initializing : ', e)
    })

  if (playBtn) {
    playBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (playWrapper && pauseWrapper) {
        playWrapper.classList.add('playing')
        pauseWrapper.classList.add('playing')
        if (!audioSpeech) {
          return false
        }

        audioSpeech
          .speak({
            text: readText.replaceAll('\n', ' '),
            queue: false,
            listeners: {
              onstart: () => {
                playing = true
                progressBar.classList.add('animate')
              },
              onend: () => {
                playing = false
              },
              onresume: () => {
                playing = false
                progressBar.classList.remove('animate')
              },
              onboundary: (event) => {
                console.log(event.name + ' boundary reached after ' + event.elapsedTime + ' milliseconds.')
              }
            }
          })
          .then((data) => {
            console.log('Success !', data)
            progressBar.classList.remove('animate')
            playWrapper.classList.remove('playing')
            pauseWrapper.classList.remove('playing')
          })
          .catch((ev) => {
            console.error('An error occurred :', ev)
            progressBar.classList.remove('animate')
            playWrapper.classList.remove('playing')
            pauseWrapper.classList.remove('playing')
          })

        playing = !playing
      }
    })
  }

  if (pauseBtn) {
    pauseBtn.addEventListener('click', (e) => {
      e.preventDefault()
      if (playWrapper && pauseWrapper) {
        if (playing) {
          audioSpeech.pause()
        }
        playWrapper.classList.remove('playing')
        pauseWrapper.classList.remove('playing')
      }
    })
  }
}
